import React, { useMemo } from 'react';

import CheckboxItem from './CheckboxItem';

import * as S from './styles';

interface ICheckboxProps {
  type: 'category' | 'brand';
  items: Array<any>;
  handleSelect(id: Array<number>, remove: boolean): void;
  className?: string;
}

const Checkbox: React.FC<ICheckboxProps> = ({
  type,
  items,
  handleSelect,
  className = '',
}) => {
  const categoryThreeOptions = useMemo(() => {
    if (!items.length) return [];

    const categoryThreeEdited = items.map(item => {
      return {
        ...item,
        value: item.id,
        label: item.nome,
      };
    });
    return categoryThreeEdited;
  }, [items]);

  return (
    <S.Container className={`checkbox ${className}`}>
      {categoryThreeOptions.map(option => (
        <CheckboxItem
          type={type}
          handleSelect={handleSelect}
          option={option}
          key={option.id}
        />
      ))}
    </S.Container>
  );
};

export default Checkbox;
